/**
 * Application configuration
 * Centralized config for production deployment
 * 
 * Replace all import.meta.env.VITE_* references with values from this file
 */

// Error Tracking (Highlight.io)
export const HIGHLIGHT_CONFIG = {
  enabled: true,
  useEU: true,
  environment: 'production',
  projectId: 'ney0459d',
  samplingRate: 0.1, // 10% sampling
} as const;

// Analytics (Plausible)
export const ANALYTICS_CONFIG = {
  enabled: false, // Phase 2 cut: <10 users — re-enable later
  domain: 'app.trywren.app',
  src: 'https://plausible.io/js/script.js',
  api: 'https://plausible.io/api/event',
} as const;

// Legal / Data Controller
export const LEGAL_CONFIG = {
  controllerName: 'Wren (by IKAI Design)' as string,
  controllerEmail: 'support@trywren.app' as string,
  controllerAddress: '' as string, // PostNL pending
  privacyReady: false as boolean, // Show "address pending" notice
};

// Version / Build
export const BUILD_CONFIG = {
  version: 'v0.9.5-beta',
  gitSha: import.meta.env.VITE_GIT_SHA?.slice(0, 7) || 'dev',
} as const;

// Feature Flags
export const FEATURE_FLAGS = {
  showBetaTesterBadge: true, // Set to false when beta ends
} as const;

// User Testing (Maze)
export const MAZE_CONFIG = {
  enabled: false, // Phase 2 cut: <10 users — re-enable later
  apiKey: '531ebe93-1931-4059-8765-ef9e8cd7b13a',
  testModeOnly: true, // Only load when ?test=true is in URL
} as const;

/**
 * Phase 2 Feature Flags
 * --------------------------------------------------------------
 * Wren's stabilization plan (.lovable/plan.md) cuts every non-core
 * feature behind a flag until the app is trustworthy for 60 days
 * with zero data-loss reports. Flip individual flags back to `true`
 * once a feature is re-validated. `master` is a kill-switch that
 * overrides every sub-flag when `false`.
 */
export const PHASE_2_FEATURES = {
  master: false,
} as const;

export const isPhase2Enabled = (_feature: string): boolean => false;